import { createApp } from 'vue'
import router from "@/router"
import App from './App.vue'
import { createPinia } from "pinia";
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'



// element plus
import 'element-plus/es/components/message/style/css'
import 'element-plus/es/components/image-viewer/style/css'

// icon
import '@material-design-icons/font';

// app style
import '@/assets/style/tailwind.css';
import '@/assets/style/index.less';


const pinia = createPinia();
const app = createApp(App)
console.log('版本号:1.0.1')
app.use(ElementPlus, {
    locale: zhCn,
})
app
    .use(pinia)
    .use(router)
    .mount('#app');
